import React from 'react';
import PropTypes from 'prop-types';

import Config from '../../Config';

const config = new Config();

const JointContactHeading = ({ isTseu, handleTseuModalToggleOn }) => {
  return (
    <div >
      <h1 className="h2_subHeading">
        Joint Account Holder
        {
          config.tseuChangesEnabled && isTseu &&
          <button
            type="button"
            className="tradingHelpButton"
            onClick={handleTseuModalToggleOn}
          >
            <i className="material-icons title-help">help</i>
          </button>
        }
      </h1>
    </div>
  );
};

JointContactHeading.propTypes = {
  isTseu: PropTypes.bool.isRequired,
  handleTseuModalToggleOn: PropTypes.func.isRequired,
};

export default JointContactHeading;
